import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const scaleDeleteAtom = createMutationAtomFactory(
  'settings.scaleDelete',
  (params: { id: string }) => ({
    iotScaleDelete: {
      __args: {
        id: params.id,
      },
    },
  }),
);
